/**
 * Match a Jira-style ticket key: a project key (2+ chars, letters/digits,
 * starting with a letter) followed by a hyphen and an issue number. Case
 * insensitive — matches are upper-cased before being returned.
 * Examples: CORE-43704, core-123, Ab1-12, proj-7
 */
const jiraTicketPattern = /\b[A-Za-z][A-Za-z0-9]+-[0-9]+\b/g;

/**
 * Extract unique Jira ticket keys from a list of commit / save messages,
 * preserving the order in which they were first encountered. Returned keys
 * are always upper-case regardless of how they appeared in the source.
 */
export function extractJiraTickets(messages: readonly string[]): string[] {
  const seen = new Set<string>();
  const tickets: string[] = [];
  for (const message of messages) {
    if (!message) {
      continue;
    }
    const matches = message.match(jiraTicketPattern);
    if (!matches) {
      continue;
    }
    for (const match of matches) {
      const ticket = match.toUpperCase();
      if (!seen.has(ticket)) {
        seen.add(ticket);
        tickets.push(ticket);
      }
    }
  }
  return tickets;
}
